var frm = $("#resetPassword");

$('#cancelBtn').click(function (e){
    window.location.replace("./index.php");
});

$( '#inputUsername' ).focus(function(){
    $('#messageModal').modal('hide');
});

// Generates error message
function generateMessage(title, message, btnTxt, btnLink) {
    $('#messageModalTitle').text(title);
    $('#messageModalMessage').text(message);
    $('#messageModalButton').text(btnTxt);
    $('#messageModalButton').attr('href', btnLink);
    var modal = UIkit.modal('#messageModal');
    modal.show();
}

$('#submitBtn').click(function (e)
{
    var username =  $( '#inputUsername' ).val();

    if(username !== '') {
        $.ajax({
            type: 'POST',
            url: 'api/v1.0/users/forgotPassword',
            data: {username: username},
            success: function (data) {
                try {
                    if (checkError(data)) {
                        generateMessage("Success", "An email has been sent to " + data['rows'][0]['to'] +  " with a link to reset your password.", "Close", "index.php");
                    }
                }
                catch (error) {
                    handleExceptionError(error);
                }
            },
            error: function (jqXHR, exception, error )
            {
                generateMessage("Oops", error, "Close", "forgotpassword.php");
                $('#inputUsername').val("");
            }
        });
    }
    else{
        generateMessage("Oops", 'You must enter your ARCBOX username', "Close", "forgotpassword.php");
	}
		e.preventDefault();
});